import httpClient from './httpClient'

const path = 'block_download'

export default {
  async getBlockDownload() {
    let ret = await httpClient.get(path)
    return ret
  },
  async updateBlockDownload(data) {
    let ret = await httpClient.put(path, data)
    return ret
  },
}
